<!-- 设备抵押基本信息 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    ref="topData"
    :rules="rules"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  // import API from '@/api/purchaseSalesCenter/credit/equipmentMortgage.js';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'baseInfo',
    components: {
      BaseForm,
    },
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      options() {
        // const data = this.formData;
        return [
          {
            type: 'dict',
            label: '状态',
            prop: 'mortgageStatus',
            dictType: 'mortgage_status',
            clearable: true,
            disabled: true,
          }, //状态
          {
            type: 'select',
            label: '公司名称',
            prop: 'businessCompanyCode',
            placeholder: '请选择公司名称',
            options: this.companyList,
            currentValue: this.formData.businessCompanyName,
          }, //公司
          {
            type: 'dict',
            label: '币种',
            prop: 'currencyCode',
            clearable: true,
            dictType: 'all_currency',
            disabled: true,
            currentValue: this.formData.currencyName,
          }, //币种编码
          {
            prop: 'customerCode',
            label: '客户',
            type: 'searchTable',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.adminFlag,
              department: this.userInfo.department,
              company: this.userInfo.company,
            },
            currentValue: this.formData.customerName,
            isMultiple: true,
            disabled: false,
          }, //客户
          {
            type: 'searchTable',
            prop: 'businessPersonName',
            label: '业务员',
            isMultiple: true,
            // name: 'businessPersonName',
            // getName: 'personName',
            // code: 'businessPersonNo',
            // getCode: 'personNo',
            disabled: true,
            currentValue: this.formData.businessPersonName,
            searchType: 'personnel',
          }, //业务员
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      rules() {
        return {
          businessCompanyCode: [
            {
              required: true,
              message: '请选择公司',
              trigger: ['blur', 'change'],
            },
          ],
          businessPersonName: [
            {
              required: true,
              message: '请选择业务员',
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    watch: {
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
    },
    data() {
      return {
        formData: {
          id: '',
          businessPersonNo: '', //业务员
          businessPersonName: '', //业务员
          businessCompanyCode: '', //公司
          businessCompanyName: '', //公司
          businessDepartmentCode: '', //部门
          businessDepartmentName: '', //部门
          mortgageStatus: '', //状态
          customerName: '', //客户名称
          customerCode: '', //客户编码
          customerType: '', //客户类型
          currencyCode: '', // 币种编码
          currencyName: '', // 币种名称
        },
        initFlag: true, //查询详情进入页面时，先不执行handleChange
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      this.getCompany();
      this.getLedger(this.formData.businessCompanyCode);
    },
    methods: {
      getDetail(data) {
        console.log(this.userInfo);
        this.formData = data;
        this.initFlag = true;
        this.$nextTick(() => {
          this.initFlag = false;
        });
      },
      handleChange(v, prop) {
        this.formData[prop] = v[prop];
        console.log(v[prop]);
        if (prop == 'businessCompanyCode') {
          this.formData.businessCompanyCode = v[prop];
          this.formData.businessCompanyName = v[prop]
            ? this.companyList.find((it) => it.value == v[prop]).label
            : '';
          this.formData.businessDepartmentCode = '';
          this.formData.businessDepartmentName = '';
          if (!v[prop]) return;
          this.getLedger(this.formData.businessCompanyCode);
        } else if (prop == 'customerCode') {
          //客户
          this.formData.customerName = v[prop][0].partnerZhName || '';
          this.formData.customerType = v[prop][0].partnerForm || '';
          this.formData.customerCode = v[prop][0].partnerCode || '';
        }
      },
      // 获取公司对应本币位
      getLedger(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            console.log(res[0].currencyName);
            this.formData.currencyCode = res[0].currencyCode;
            this.formData.currencyName = res[0].currencyName;
          } else {
            //没有查询到公司账套
            this.formData.currencyCode = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      // 加载公司列表
      async getCompany() {
        const selectStatus = await this.$axios.get(
          BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      // 千分位
      toLocaleString(num) {
        return num && num.toLocaleString();
      },
      // 校验
      getVal() {
        return new Promise((resolve, reject) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
